import React from 'react';
import { TextField, withStyles, colors } from '@material-ui/core';

const black64 = 'rgba(0, 0, 0, 0.64)';
const black32 = 'rgba(0, 0, 0, 0.32)';

const _fontFamily = (props) =>
  props.isprimary === 'true'
    ? 'Fredoka One, cursive'
    : 'Varela Round, sans-serif';
const _color = (props) =>
  props.isprimary === 'true' ? colors.red[300] : black32;
const _focusedColor = (props) =>
  props.isprimary === 'true' ? colors.red[300] : black64;

const StyledTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      fontFamily: 'Varela Round, sans-serif',
      '& fieldset': {
        borderColor: black64,
      },
      '&:hover fieldset': {
        borderColor: colors.red[200],
      },
      '&.Mui-focused fieldset': {
        borderColor: colors.red[400],
      },
      '&.Mui-error': {
        '& fieldset': {
          borderColor: colors.red[900],
        },
      },
    },
    '& .MuiInputLabel-outlined': {
      fontFamily: _fontFamily,
      color: _color,
      '&.Mui-focused': {
        color: _focusedColor,
      },
    },
    '& .MuiFormHelperText-root': {
      fontFamily: 'Fredoka One, cursive',
      '&.Mui-error': {
        color: colors.red[900],
      },
    },
    '& .MuiInputBase-root': {
      fontFamily: 'Varela Round, sans-serif',
      lineHeight: 1.5,
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: black64,
    },
    '& .MuiInput-underline:hover:before': {
      borderBottomColor: colors.red[200],
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: colors.red[400],
    },
    '& .MuiInput-underline:error': {
      borderBottomColor: 'green',
    },
  },
})(TextField);

const MainTextfield = ({
  label,
  variant = 'outlined',
  fullWidth = false,
  value,
  onChange,
  error,
  helperText,
  autoFocus = false,
  onKeyDown,
  readOnly = false,
  endAdornment,
  type = 'text',
  multiline = false,
  isPrimary = true,
}) => {
  return (
    <StyledTextField
      type={type}
      label={label}
      variant={variant}
      fullWidth={fullWidth}
      value={value}
      onChange={onChange}
      helperText={helperText}
      error={error}
      autoFocus={autoFocus}
      onKeyDown={onKeyDown}
      multiline={multiline}
      isprimary={isPrimary.toString()}
      InputProps={{
        readOnly,
        endAdornment,
      }}
    ></StyledTextField>
  );
};

export default MainTextfield;
